var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLayout',{attrs:{"title":_vm.title,"palette":_vm.palette,"units":"%"},scopedSlots:_vm._u([{key:"notes",fn:function(){return [_vm._v(" The datapoints for 2022 and 2023 are considered provisional due to the time lag in filing applications in the PATSTAT database. ")]},proxy:true}])},[_c('DataGetter',{attrs:{"url":_vm.apiRoute,"params":{
      startYear: 2000,
      allYears: true,
      countryISO: _vm.countryISO,
      category:
        _vm.category === 'Clean Energy'
          ? 'Clean Energy'
          : [
              'Upstream',
              'Processing downstream',
              'Transmission distribution',
            ],
      topic: 'Patents',
      indicator: 'Detail',
    },"lazy":""},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('DataSlicer',{attrs:{"data":data,"x-axis-dimension":"year","y-axis-dimension":_vm.yAxisDimension,"value-dimension":"value","data-formatter":_vm.category === 'Clean Energy' ? null : _vm.mergeData},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData }){return [_c('Chart',{attrs:{"options":{
          ..._vm.chartOptions,
          series: [...slicedData]
            .sort(
              _vm.seriesOrder
                ? (a, b) =>
                    _vm.seriesOrder.indexOf(a.name) - _vm.seriesOrder.indexOf(b.name)
                : (a, b) => (a.name > b.name ? 1 : -1)
            )
            .map((series, i) => ({
              ...series,
              colorIndex:
                (_vm.seriesOrder ? _vm.seriesOrder.indexOf(series.name) : i) % 20,
            })),
        }}})]}}],null,true)})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }